export interface ApiErrorResponse {
    message: string;
    errorType?: string;
    statusCode: number;
}

export function isHomeTileConflictError(error: unknown): boolean {
    if (typeof error !== 'object' || error === null) {
        return false;
    }

    const axiosError = error as any;
    const errorResponse = axiosError?.response?.data as ApiErrorResponse | undefined;

    return errorResponse?.errorType === 'HOME_TILE_ALREADY_EXIST';
}

export function getErrorMessage(error: unknown): string {
    if (typeof error !== 'object' || error === null) {
        return 'Неизвестная ошибка';
    }

    const axiosError = error as any;
    const errorResponse = axiosError?.response?.data as ApiErrorResponse | undefined;

    return errorResponse?.message ||
        axiosError?.message ||
        'Ошибка при добавлении подборки на главную';
}

